<template>
   <div id="carouselsz">
       <div class="tos">
          <!-- <el-form :inline="true" :model="carouselPageDto" label-width="100px"  class="demo-form-inline">
             <el-form-item label="关键字：">
                <el-input v-model="carouselPageDto.keyWord"></el-input>
             </el-form-item>
             <el-form-item>
                <el-button type="primary" @click="sjhsearchFor(carouselPageDto.keyWord)">查询</el-button>
             </el-form-item>
          </el-form> -->
          <!-- <el-button class="right-item"  type="primary" @click=newoks()>添加轮播图</el-button> -->
          <el-button style="margin-left: 30px;  margin-left: auto;"  type="primary" @click=newoks()>添加轮播图</el-button>
       </div>
       <div class="tableform">
         <el-table
             :data="tableData"
             border
             stripe
             :cell-style="{'text-align':'center'}"
             :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
             style="width: 100%">
             <el-table-column
                prop="carouselImgUrl"
                label="轮播图"
                >
                <template slot-scope="scope">
                  <span v-for="(item, index) in scope.row.carouselImageVoList" :key="index">
                     <img style="margin-left: 10px;" :src="item.carouselImgUrl" class="image-column" />
                  </span>
               </template>
             </el-table-column>
             <el-table-column
                prop="status"
                label="是否开启"
                >
                <template slot-scope="scope">
                  <el-switch
                    @change="handleSwitchChange(scope.row, $event)"
                     v-model="scope.row.status"
                     active-color="#13ce66"
                     inactive-color="#DBDBDB"
                     active-value="1"
                     inactive-value="0">
                  </el-switch>
                  </template>
             </el-table-column>
             <el-table-column
                prop="createDate"
                label="创建时间"
                >
                <template slot-scope="{row:{ createDate }}">
                {{ createDate|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="remark"
                label="备注"
                >
                <template slot-scope="{row:{ remark }}">
                {{ remark|| "—" }}
                </template>
             </el-table-column>
             <el-table-column fixed="right" label="操作" width="280">
                <template slot-scope="scope">
                     <i title="编辑" class="el-icon-alixiugai" style="color: #1296db;cursor: pointer;"  @click=bianjiClick(scope.row) ></i>
                     <i title="删除"  class="el-icon-alishanchu" style="color: #d81e06;cursor: pointer;"  @click=dels(scope.row) ></i>
                </template>
             </el-table-column>
          </el-table>
          <div class="btnbox">
             <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="carouselPageDto.pageNum"
                :page-sizes="[10, 15, 20]"
                :page-size="carouselPageDto.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="this.totals">
             </el-pagination>
          </div>
       </div>
       <!-- 添加海报弹框 -->
       <el-dialog title="添加轮播图" :visible.sync="increase" width="32%" class="zcyhtk"  @close='closeDialog'>
            <el-form ref="carouselBatchDto" :model="carouselBatchDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
               <el-form-item label="描述：">
                    <el-input v-model="carouselBatchDto.carouselDesc" placeholder="请输海报描述"></el-input>
               </el-form-item>
               <el-form-item label="备注信息：">
                    <el-input v-model="carouselBatchDto.remark" placeholder="请输入备注"></el-input>
               </el-form-item>
               <div v-for="(item,index) in carouselAddDtoList" :key="index" class="tjhbdlb">
                  <el-button class="tjhbdlban" v-if="index === 0" type="primary" plain @click="yddDtoList">添加</el-button>
                  <i title="删除" v-else class="el-icon-alishanchu tjhbdlban" style="color: #d81e06; width: 50px; cursor: pointer;" @click=zddscdelete(index)></i>
                  <el-form-item :label="`第${index + 1}张：`">
                  <el-upload
                     class="upload-demo"
                     action="#"
                     ref="upload"
                     :limit="1"
                     :http-request="handleRequest"
                     :on-remove="handleRemove(index,item)"
                     :before-upload="beforeUpload"
                     :on-success="handleSuccess(index)"
                     :on-error="handleError"
                     :on-exceed="handleExceed"
                     list-type="picture-card"
                     :file-list="item.fileList"
                  >
                  <i class="el-icon-plus"></i>
                  <div class="el-upload__tip" slot="tip">图片尺寸建议450px*300px</div>
                  </el-upload>
                  </el-form-item>
                  <el-form-item label="添加产品：" >
                     <el-select v-model="item.productId" filterable placeholder="请选择产品分类" style="width: 60%;">
                  <el-option
                     v-for="item in fjfltableData"
                     :key="item.productId"
                     :label="item.productTitle"
                     :value="item.productId"
                     class="hbgltjcp"
                  >
                        <template #default>
                        <div class="hbgltjcpxllmdys">
                           <img :src="item.productImageUrl" alt="" class="image-column"/>
                           <span>{{ item.productTitle }} </span>
                           <span style="display: inline-block; margin-left: 20px; color: #d81e06;">{{ item.priceRange }} </span>
                        </div>
                        </template>
                     </el-option>
                     </el-select>
                  </el-form-item>
               </div>
                  <!-- <el-input placeholder="请输入产品名称" v-model="fycarouselPageDto.keyWord">
                     <template #suffix >
                        <el-icon style="cursor: pointer;padding-right: 10px;margin-top: 6px;font-size: 20px; color: black;" name="search"></el-icon>
                     </template>
                  </el-input> -->
               <!-- <div class="fytableform">
                  <el-table
                     :data="fytableData"
                     border
                     stripe
                     :cell-style="{'text-align':'center'}"
                     :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
                     style="width: 100%">
                     <el-table-column
                        prop="position"
                        label="引导语位置"
                        >
                        <template slot-scope="{row:{ position }}">
                        {{ position|| "—" }}
                        </template>
                     </el-table-column>
                     <el-table-column
                        prop="guidanceContent"
                        label="引导语内容"
                        >
                        <template slot-scope="{row:{ guidanceContent }}">
                        {{ guidanceContent|| "—" }}
                        </template>
                     </el-table-column>
                     <el-table-column
                        prop="remark"
                        label="备注"
                        >
                        <template slot-scope="{row:{ remark }}">
                        {{ remark|| "—" }}
                        </template>
                     </el-table-column>
                     <el-table-column fixed="right" label="操作" width="280">
                        <template slot-scope="scope">
                              <i class="el-icon-alixiugai" style="color: #1296db;cursor: pointer;"  @click=bianjiClick(scope.row) ></i>
                              <i class="el-icon-alishanchu" style="color: #d81e06;cursor: pointer;"  @click=dels(scope.row) ></i>
                        </template>
                     </el-table-column>
                  </el-table>
                  <div class="btnbox">
                     <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="fycarouselPageDto.pageNum"
                        :page-sizes="[10, 15, 20]"
                        :page-size="fycarouselPageDto.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="this.fytotals">
                     </el-pagination>
                  </div>
               </div> -->
               </el-form>
            <div slot="footer">
                <el-button @click="increase = false">取 消</el-button>
                <el-button type="primary"  @click="submitForm('carouselBatchDto',carouselBatchDto)">确 定</el-button>
            </div>
       </el-dialog>
       <!-- 修改弹框 -->
       <el-dialog title="修改" :visible.sync="dialogFormVisible" width="32%" class="zcyhtk"  @close='closeDialog'>
         <el-form ref="carouselBatchDto" :model="carouselBatchDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
               <el-form-item label="描述：">
                    <el-input v-model="carouselBatchDto.carouselDesc" placeholder="请输海报描述"></el-input>
               </el-form-item>
               <el-form-item label="备注信息：">
                    <el-input v-model="carouselBatchDto.remark" placeholder="请输入备注"></el-input>
               </el-form-item>
               <div v-for="(item,index) in carouselAddDtoList" :key="index" class="tjhbdlb">
                  <el-button class="tjhbdlban" v-if="index === 0" type="primary" plain @click="yddDtoList">添加</el-button>
                  <i title="删除" v-else class="el-icon-alishanchu tjhbdlban" style="color: #d81e06; width: 50px; cursor: pointer;" @click=zddscdelete(index)></i>
                  <el-form-item :label="`第${index + 1}张：`">
                  <el-upload
                     class="upload-demo"
                     action="#"
                     ref="upload"
                     :limit="1"
                     :http-request="handleRequest"
                     :on-remove="handleRemove(index,item)"
                     :before-upload="beforeUpload"
                     :on-success="handleSuccess(index)"
                     :on-error="handleError"
                     :on-exceed="handleExceed"
                     list-type="picture-card"
                     :file-list="item.fileList"
                  >
                  <i class="el-icon-plus"></i>
                  <div class="el-upload__tip" slot="tip">图片尺寸建议450px*300px</div>
                  </el-upload>
                  </el-form-item>
                  <el-form-item label="添加产品：" >
                     <el-select v-model="item.productId" filterable placeholder="请选择产品分类" style="width: 60%;">
                  <el-option
                     v-for="item in fjfltableData"
                     :key="item.productId"
                     :label="item.productTitle"
                     :value="item.productId"
                     class="hbgltjcp"
                  >
                        <template #default>
                        <div class="hbgltjcpxllmdys">
                           <img :src="item.productImageUrl" alt="" class="image-column"/>
                           <span>{{ item.productTitle }} </span>
                           <span style="display: inline-block; margin-left: 20px; color: #d81e06;">{{ item.priceRange }} </span>
                        </div>
                        </template>
                     </el-option>
                     </el-select>
                  </el-form-item>
               </div>
               </el-form>
            <div slot="footer">
                <el-button @click="xgtkdfdqx">取 消</el-button>
                <el-button type="primary"  @click="gxsubmitForm('carouselBatchDto',carouselBatchDto)">确 定</el-button>
            </div>
       </el-dialog>
   </div>
   </template>
   <script>
   import ipConfig from "../../utils/ipconfig";
   import Compressor from 'compressorjs';
      export default {
      name:'carouselsz',
      data(){
       return{
          carouselPageDto:{
             pageNum:1,
             pageSize:10,
             carouselDesc:null,
             carouselImageVoList:[],
             remark:null,
             status:0,
          },
          fycarouselPageDto:{
             pageNum:1,
             pageSize:200,
             keyWord:null,
          },
          tableData: [],
          fytableData: [],
          totals:10,
          fytotals:10,
          increase:false,
          dialogFormVisible:false,
          carouselBatchDto:{
            carouselDesc:null,
            carouselAddDtoList:[],
            remark:null,
            status:'1',
            carouselId:null
         },
         fileList:[],
         zcrules: {
            position: [
            { required: true, message: '请选择引导语位置', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
            guidanceContent: [
            { required: true, message: '请输入引导语内容', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
         },
         fjfltableData: [],
         carouselAddDtoList:[
            {
               carouselImgUrl:null,
               productId:null,
               fileList:[],
               sort:null
            },
         ],
         posterIdbzdid:null
       }
      },
      created(){
       this.getlist(this.carouselPageDto)
      },
      mounted(){
      },
      methods:{
         fygetlist(fyposterPageDto) {
          this.$api.queryProduct(fyposterPageDto)
          .then((res) => {
                if (res.data.code == 200) {
                   let data = res.data.data.records
                  data.forEach(element => {
                     if (element.productImageUrl.startsWith('https')) {
                        element.productImageUrl = element.productImageUrl;
                     } else {
                        element.productImageUrl = ipConfig.baseUrl+element.productImageUrl;
                     }
                  });
                  this.fytableData = data
                  this.fytotals = res.data.data.total
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
       getlist(carouselPageDto) {
          this.$api.lbtlbqueryPage(carouselPageDto)
          .then((res) => {
                if (res.data.code == 200) {
                  let data = res.data.data.records
                  data.forEach(element => {
                     element.status = element.status.toString()
                     element.carouselImageVoList.forEach(item => {
                        if (item.carouselImgUrl.startsWith('https')) {
                           item.carouselImgUrl = item.carouselImgUrl;
                        } else {
                           item.carouselImgUrl = ipConfig.baseUrl+item.carouselImgUrl;
                        }
                     });
                  });
                  this.tableData = data
                  this.totals = res.data.data.total
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
     
       sjhsearchFor(type){
          this.carouselPageDto.keyWord = type
          this.getlist(this.carouselPageDto)
       },
       submitForm(formName){
         this.carouselAddDtoList.forEach((element,index) => {
            element.sort = index+1
         });
         this.$set(this.carouselBatchDto, 'carouselAddDtoList', this.carouselAddDtoList);
         this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$api.AddCarousel(this.carouselBatchDto).then((res) => {
                if (res.data.code == 200) {
                    this.increase = false
                    this.dialogFormVisible = false
                    this.carouselBatchDto={
                        carouselDesc:null,
                        carouselAddDtoList:[],
                        remark:null,
                        status:'0',
                    }
                    this.carouselAddDtoList=[
                        {
                           carouselImgUrl:null,
                           productId:null,
                           fileList:[],
                           sort:null
                        },
                    ]
                    this.getlist(this.carouselPageDto)
                    this.$message.success(res.data.message)
                } else {
                  this.$message.error(res.data.message)
                }
              })
            } 
          });
      },
      gxsubmitForm(formName){
         this.carouselAddDtoList.forEach((element,index) => {
            element.sort = index+1
         });
         this.$set(this.carouselBatchDto, 'carouselAddDtoList', this.carouselAddDtoList);
         this.$set(this.carouselBatchDto, 'carouselId', this.posterIdbzdid);
         this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$api.updateCarousel(this.carouselBatchDto).then((res) => {
                if (res.data.code == 200) {
                    this.increase = false
                    this.dialogFormVisible = false
                    this.carouselBatchDto={
                        carouselDesc:null,
                        carouselAddDtoList:[],
                        remark:null,
                        status:'0',
                        carouselId:null
                    }
                    this.carouselAddDtoList=[
                        {
                           carouselImgUrl:null,
                           productId:null,
                           fileList:[],
                           sort:null
                        },
                    ]
                    this.posterIdbzdid =null
                    this.getlist(this.carouselPageDto)
                    this.$message.success(res.data.message)
                } else {
                  this.$message.error(res.data.message)
                }
              })
            } 
          });
      },
      bianjiClick(row) {
         this.posterIdbzdid = row.carouselId
         this.dialogFormVisible = true;
         this.bjtsClick(row.carouselId)
         this.fygetlist(this.fycarouselPageDto)
      },
      bjtsClick(carouselId){
         this.$api.hqlbtxqdetail({
                  carouselId:carouselId
            }).then((res)=>{
               if (res.data.code == 200) {
                  let data = res.data.data
                  if (data.carouselImageVoList.length == 0) {
                     data.carouselImageVoList=[
                        {
                           carouselImgUrl:null,
                           productId:null,
                           fileList:[],
                           sort:null
                        },
                    ]
                  }
                  data.carouselImageVoList = data.carouselImageVoList.map(item => ({
                        ...item,
                        fileList: []
                  }));
                  data.carouselImageVoList.forEach(element => {
                     if (element.fileList) {
                        if (element.carouselImgUrl) {
                           if (element.carouselImgUrl.startsWith('https')) {
                              element.carouselImgUrl = element.carouselImgUrl;
                           } else {
                              element.carouselImgUrl = ipConfig.baseUrl+element.carouselImgUrl;
                           }
                           element.fileList.push({
                              url:element.carouselImgUrl
                           })
                        }
                     }
                  });
                  this.carouselAddDtoList = data.carouselImageVoList
                  this.carouselBatchDto = data
                  } else {
                     this.$message.error(res.data.message)
                  }
            })
      },
      dels(e) {
          this.$confirm('是否确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.deleteCarousel({
               carouselId:e.carouselId
                }).then((res) => {
                  if(res.data.code==200){
                     this.getlist(this.carouselPageDto)
                     this.$message.success(res.data.message)
                  }else{
                     this.$message.error(res.data.message)
                  }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
      handleRequest(request) {
         const formData = new FormData();
         formData.append('file', request.file); // 这里的 'file' 是后端接收文件的字段名
         this.$api.uploadPackage({
            file:request.file
         }).then((res) => {
                if (res.data.code == 200) {
                  this.$message.success(res.data.message)
                  request.onSuccess(res.data.data); // 当请求成功时，调用 onSuccess
                } else {
                    this.$message.error(res.data.message)
                }
            })
      },
      handleExceed(files, fileList) {
         this.$message.warning('已超出只能上传一张图片的限制，请先移除现有图片再上传新图片。');
      },
      // 删除图片
      handleRemove(index,item) {
         return (file, fileList) => {
         if(item){
            if (item.fileId) {
            this.$api.scwjremoveFile({
               fileId:item.fileId
            }).then((res) => {
                  if (res.data.code == 200) {
                     console.log(res,'resresresresresres');
                  this.$message.success(res.data.message)
                  } else {
                     this.$message.error(res.data.message)
                  }
            })
            }else{
               item.carouselImgUrl =null
            }
         }
         // else {
         //    console.log(222222222222222222222);
         //    this.carouselAddDtoList[index].carouselImgUrl= null
         // }
         };
      },
      // 图片上传失败的回调函数
      handleError(error, file, fileList) {
         this.$message.error('图片上传失败');
      },
      // 上传前的处理函数
      // beforeUpload(file) {
      //   // 限制文件类型
      //   const isImage = file.type.startsWith('image/');
      //    const isVideo = file.type === 'video/mp4';
      //    if (!isImage && !isVideo) {
      //    this.$message.error('只能上传图片或 MP4 格式的视频文件');
      //    return false;
      //    }
      //    // 限制文件大小
      //    const maxSize = 30 * 1024 * 1024; // 100MB
      //    if (file.size > maxSize) {
      //    this.$message.error('文件大小不能超过 30MB');
      //    return false;
      //    }
      //    return true;
      // },
      beforeUpload(file) {
         return new Promise((resolve, reject) => {
            if (file.type.startsWith('video/mp4')) {
              resolve();
            } else if (file.type.startsWith('image')) {
              new Compressor(file, {
                quality: 0.85,        // 压缩质量，范围 0 - 1
                maxWidth: 800,       // 图片最大宽度
                maxHeight: 800,      // 图片最大高度
                mimeType: 'image/jpeg', // 强制压缩为 JPEG 格式
                success: (compressedFile) => {
                  file.compressed = compressedFile;
                  resolve();
                },
                error: (err) => {
                  console.error('图片压缩失败', err);
                  reject('图片压缩失败');
                },
              });
            } else {
              reject('只支持上传图片和 MP4 格式视频');
            }
         });
        },
      // 图片上传成功的回调函数
      handleSuccess(index) {
         return (response, file, fileList) => {
          this.carouselAddDtoList[index].carouselImgUrl =response.oriFileUrl
          this.carouselAddDtoList[index].fileId = response.fileId
         //  this.partsAddDto.partsVariantsAddDtos[index].ggtpfileList.push({
         //    name: file.name,
         //    url: ipConfig.baseUrl+response.oriFileUrl
         //  });
        };
      },
       newoks() {
         this.increase = true
         this.fygetlist(this.fycarouselPageDto)
      },
      fygetlist(fycarouselPageDto) {
          this.$api.queryProduct(fycarouselPageDto)
          .then((res) => {
                if (res.data.code == 200) {
                   let data = res.data.data.records
                   data.forEach(element => {
                     if (element.productImageUrl.startsWith('https')) {
                        element.productImageUrl = element.productImageUrl;
                     } else {
                        element.productImageUrl = ipConfig.baseUrl+element.productImageUrl;
                     }
                   });
                   this.fjfltableData = data
                   console.log(this.fjfltableData,'this.fjfltableData');
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
      closeDialog(){
        this.xgtkdfdqx()
      },
      handleSwitchChange(row, value) {
         this.$api.switchCarousel({
            carouseId:row.carouselId,
            status:row.status,
         })
          .then((res) => {
                if (res.data.code == 200) {
                 this.$message.success(res.data.message)
                  this.getlist(this.carouselPageDto)
               } else {
               this.$message.error(res.data.message)
               }
          })
      },
      xgtkdfdqx(){
        this.dialogFormVisible = false;
        this.carouselBatchDto={
            carouselDesc:null,
            carouselAddDtoList:[],
            remark:null,
            status:'0',
         }
         this.carouselAddDtoList=[
            {
               carouselImgUrl:null,
               productId:null,
               fileList:[],
               sort:null
            },
         ]
         this.posterIdbzdid =null
      },
      handleCurrentChange(val) {
         this.carouselPageDto.pageNum = val
          this.getlist(this.carouselPageDto)
      },
      handleSizeChange(val) {
         this.carouselPageDto.pageSize = val
          this.getlist(this.carouselPageDto)
      },
      yddDtoList(){
      if (this.carouselAddDtoList.length<6) {
         let data = {
            carouselImgUrl:null,
            productId:null,
            fileList:[],
            sort:null
         }
         this.carouselAddDtoList.push(data)
      }else{
         this.$message({
            message: '最多添加六条',
            type: 'warning'
         });
      }
      },
      zddscdelete(index){
        this.carouselAddDtoList.splice(index, 1);
      },
      // fyhandleCurrentChange(val) {
      //    this.fycarouselPageDto.pageNum = val
      //    //  this.getlist(this.queryMaterialDto)
      // },
      // fyhandleSizeChange(val) {
      //    this.fycarouselPageDto.pageSize = val
      //    //  this.getlist(this.queryMaterialDto)
      // },
      }
      }
   </script>
   <style scoped>
#carouselsz {
   width: 100%;
   height: 100%;
   overflow-y: auto;
   background-color: #fff;
   padding:0 0 0 30px;
   box-sizing: border-box;
}
.tos {
   display: flex;
   /* justify-content: space-between; */
   align-items: center;
   /* background: yellow; */
   margin-bottom: 20px;
   margin-left: -30px;
 }
 .elrow{
   box-sizing: border-box;
   width: 20%;
   margin-top: -6px;
   margin: 0 40px 0 20px;
 }
 .elrowleft{
   width: 80%;
   float: left;
   box-sizing: border-box;
 }
 .elrowleft input{
   border: 2px solid #1b93ed !important;
   border-radius: 0 !important;
   width: 100%;
   -webkit-appearance: none;
   appearance: none;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #929da5;
   box-sizing: border-box;
   color: #1f3d35;
   font-size: 14px;
   height: 36px;
   line-height: 1;
   outline: none;
   padding: 3px 10px;
   transition: border-color .2s cubic-bezier(.645,.045,.355,1);
 }
 .elrowcontent{
   width: 16.66667%;
   float: left;
   box-sizing: border-box;
 }
 .search-btn {
   height: 36px;
   width: 100px;
   background: #1b93ed;
   border: 2px solid #1b93ed;
   margin: 0;
   padding: 0;
   color: #fff;
   cursor: pointer;
 }
 .right-item {
   margin-left: auto; /* Pushes the item to the right */
 }
 .tos /deep/ .el-form-item {
     margin-bottom: 0 !important;
 }
 .btnbox {
   /* background: pink; */
   display: flex;
   width: 40%;
   align-items: center;
   justify-content: space-around;
   margin: auto;
   margin-top: 30px;
}
.zcyhtk /deep/ .el-form-item__label {
   width: 120px !important;
}
.zcyhtk /deep/ .el-form-item__content {
   margin-left: 120px !important;
}
.fytableform{
   margin-left: 35px;
}
.hbgltjcp{
   height: 60px !important;
   line-height: 50px !important;
}
.hbgltjcpxllmdys{
   display: flex;
   justify-items: center;
}
.hbgltjcpxllmdys img{
   margin-right: 30px;
}
.image-column {
  width: 50px; /* 控制图片宽度 */
  height: 50px; /* 控制图片高度 */
  object-fit: cover; /* 保持图片比例填充 */
}
.tjhbdlb{
   position: relative;
}
.tjhbdlban{
   position: absolute;
   right: 0;
   top: 0;
   cursor: pointer;
   z-index: 9999;
}
.el-upload__tip{
    font-size: 14px;
    color: #0889FD;
  }
</style>


// WEBPACK FOOTER //
// src/components/marketivities/carouselsz.vue